import React from 'react';
import { Skeleton } from '@landr/maestro';

export const SampleCardSkeleton = (): JSX.Element => (
    <div data-testid="sample-card-skeleton-wrapper">
        <Skeleton height="150px" mb="16px" mr="12px" />
        <Skeleton height="16px" mt="8px" />
    </div>
);
